import Record from "slotworks/model/gameplay/records/record";
import Point from "slotworks/utils/geom/point";

export default class SpinRecord extends Record {

    public reelset: string[][];
    /**
     * 2D array where each inner array is a reel
     */
    public grid: string[][];
    public overlayGrid: string[][];

    public expansions: ExpansionDefinition[];

    public stops: number[];

    /**
     * Purely for front end use, counts the number of times the wins have cycled.
     * TODO: Perhaps move this? It's state independent so needs to be in a model,
     * but there isn't a suitable place
     */
    public timesCycled: number = 0;
    public anticipations: AnticipationInfo;

    public gameName?: string;
}

export class AnticipationInfo {
    /**
     * Which reels will show an anticipation
     */
    public reelAnticipations: boolean[] = [];
    /**
     * Which symbols on each reel should show a land animation
     */
    public landSymbols: string[][] = [];

    /**
     * Which reels trigger all symbols of a specified type to begin an anticipation animation
     */
    public anticipateSymbols: string[][] = [];
}

export class ExpansionDefinition {
    /**
     * The source of the expansion
     * For example a wild landing on reel 2, row 3 would be {x: 2, y: 3}
     */
    public source: Point;

    /**
     * List of positions which duplicate the source symbol
     * For example an expanding wild on reel 2 on a 5x3 slot:
     * [{x: 2, y: 1}, {x: 2, y: 2}, {x: 2, y: 3}]
     */
    public expansions: Point[];

    /**
     * The position which will control the expansions animation
     * If not set, the source is used
     */
    public target: Point;

    constructor(source: Point, expansions: Point[], target?: Point) {
        this.source = source;
        this.expansions = expansions;
        this.target = target || source;
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/model/gameplay/records/spin-record.ts